import { Table } from "antd"
import { USER_RECENT_LOANS } from "../PendingLoans/penColumns"

export default function UserRecentLoans({recentLoans}){


    console.log({recentLoans})

	return (
		<div>
           <p className="mb-4 text-2xl font-bold mt-10">Recent Loans</p>
            <div >
                <Table columns={USER_RECENT_LOANS} dataSource={recentLoans} scroll={{x: "max-content"}}/>
            </div>
		</div>
	)
}
